import axiosApi from '../../kits/axiosApi';

// initial state
const state = {
};

// getters
const getters = {
};

// actions
const actions = {
    getBirdMessageList({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/monitor/bird/list?sid=${post_data.sid}&from_phone_num=${encodeURIComponent(post_data.from_phone_num)}&to_phone_num=${encodeURIComponent(post_data.to_phone_num)}&foreign_id=${post_data.foreign_id}&status=${post_data.status}`)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    getSystemData({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/monitor/system/data`)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    updateCrontabSetting({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .post( aj_host + `/weapp/minipass/monitor/crontab/update`, post_data)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    getLiveChatMessageList({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/monitor/livechat/list?sid=${post_data.sid}&store_phone_num=${post_data.store_phone_num}&to_phone_num=${post_data.to_phone_num}`)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    sendLiveChatMessage({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .post( aj_host + `/weapp/minipass/monitor/livechat/send`, post_data)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    getWaitingTimeData({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/monitor/waiting/time?sid=${post_data.sid}`)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    getWaitingListData({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/monitor/waiting/list?sid=${post_data.sid}`)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    getProTransactionList({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/monitor/pro/transaction/list?stime=${post_data.stime}&etime=${post_data.etime}&page=${post_data.page}&page_size=${post_data.page_size}&cid=${post_data.cid}`)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    getVoiceaiOverview({ rootState }, post_data) {
        const aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';
        const params = new URLSearchParams();
        if (post_data.range) params.set('range', post_data.range);
        if (post_data.compare) params.set('compare', post_data.compare);
        if (post_data.date) params.set('date', post_data.date);

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/monitor/voiceai/overview?${params.toString()}`)
                .then((res) => {
                    if (res.data && res.data.code === -1) {
                        reject(new Error(res.data.error || 'Request failed'));
                        return;
                    }
                    const payload = res.data && res.data.data;
                    if (!payload || payload.code !== 100000) {
                        reject(new Error((payload && payload.msg) || 'Request failed'));
                        return;
                    }
                    resolve(payload.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    getVoiceaiStore({ rootState }, post_data) {
        const aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';
        const params = new URLSearchParams();
        if (post_data.range) params.set('range', post_data.range);
        if (post_data.compare) params.set('compare', post_data.compare);
        if (post_data.date) params.set('date', post_data.date);

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/monitor/voiceai/store?${params.toString()}`)
                .then((res) => {
                    if (res.data && res.data.code === -1) {
                        reject(new Error(res.data.error || 'Request failed'));
                        return;
                    }
                    const payload = res.data && res.data.data;
                    if (!payload || payload.code !== 100000) {
                        reject(new Error((payload && payload.msg) || 'Request failed'));
                        return;
                    }
                    resolve(payload.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    getReportDailyCompare({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/report/daily_compare_data?business=${post_data.business}&date=${post_data.date}&sort=${post_data.sort}&orderby=${post_data.orderby}&cluster=${post_data.cluster}&threshold=${post_data.threshold}`)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    getReportDailyRank({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/report/daily_compare_data?business=${post_data.business}&date=${post_data.date}&field=${post_data.field}&cluster=${post_data.cluster}`)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
};

// mutations
const mutations = {
    
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
